
//import { useOutletContext } from 'react-router-dom';
import { useEffect } from 'react';
import MapViewerReservations from '@apps/components/mapViewers/tests/MapViewerReservations';

import { useAuthBiogems } from '@cores/security/hooks/useAuthBiogems';


function PgAppHome() {
    const {currentReservations,user} = useAuthBiogems();
    //console.log("User  user.reservations in PgAppHome:",currentReservations);
    
    // useEffect(() => { //why need it?
    //     // This runs AFTER the component renders AND every time user.currentReservations changes
    //     console.log("User in PgAppHome (Effect):", currentReservations);
    //     // You should see the new value here!
    // }, [currentReservations]);


  return (
         <MapViewerReservations />
  )

}
export default PgAppHome;

